import * as React from 'react';
import { InfoBar } from 'app/components/InfoBar';
import {Link, useNavigate} from 'react-router';
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { RouteItems } from "../../routes";

export function Header(){
  const {
    services: {
      serviceAuth
    },
    isLoggedIn,
    I18N,
    getRoutes
  } = useContext(AppContext);

  const ROUTE_CONFIG: RouteItems = getRoutes();
  const navigate = useNavigate();

  const handleLogout = (event) => {
    event.preventDefault();

    serviceAuth.logout();

    navigate(ROUTE_CONFIG.LOGIN.path);
  };

  return (
    <header>
      <InfoBar />
      <dia-grid-content>
        <dia-flex-container>
        <Link to="/" title={ ROUTE_CONFIG.DASHBOARD.path } viewTransition>
          <img src="/logo-full.svg" alt="DIA Interlink Logo" height="75" />
        </Link>
          { isLoggedIn() ?
            <ul>
              <li data-logout>
                <a href="/" onClick={ handleLogout }>
                  <i data-icon-before="person-to-door"></i>{I18N.t("Abmelden")}
                </a>
              </li>
            </ul> : ''
          }
        </dia-flex-container>
      </dia-grid-content>
    </header>
  )
}
